if (process.env.NODE_ENV !== "development" && typeof window !== "undefined") {
  __webpack_public_path__ = window.__webpack_public_path__;
}
